import { modalStateEnum } from '@shared/model'

export const modalBackNavigableStates: modalStateEnum[] = [
  modalStateEnum.Login,
  modalStateEnum.Registration,
  modalStateEnum.ChangePassword,
  modalStateEnum.RestorePassword,
  modalStateEnum.ForgotPassword,
]

